import { Component, OnInit } from '@angular/core';
import { DataService } from "../services/dataservice.service";

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  private intro: string = '';
  private body: string = '';

  constructor(private dataService: DataService) {

    this.dataService.dataServiceArrived.subscribe(
      (data) =>
      {
        this.intro = data.filter((data) => {return data.Type == 'intro-about'})[0].Content;
        this.body = data.filter((data) => {return data.Type == 'body-about'})[0].Content;
      }
    )
  }

  ngOnInit() {
    this.dataService.getContent()
  }


}



// WEBPACK FOOTER //
// ./src/app/main/about/about.component.ts